<div class="field">
	<mat-form-field
		[appearance]="appearance"
		[ngClass]="{'field-error': hasError}"
		[ngClass]="{'disabled' : control?.disabled}"
	>
		<mat-label [ngClass]="{'input-error' : hasError}">{{ label }}</mat-label>
		<input
			matInput 
			autocomplete="off"
			(focus)="touched = true"
			(blur)="checkErrors($event)"
			(keydown)="onKeydown($event)"
			(keyup)="_addressRestrictionKeysOnly($event)"
			[type]="inputType"
			[formControl]="control"
			[placeholder]="placeholder"
			[maxLength]="maxLength"
			[ngClass]="{'input-error': hasError}"
		/>
		<!-- <div class="placeholder-image" *ngIf="placeholderImageUrl && !busy" [style.marginTop.px]="placeholderImageSize * -1 - 1">
			<img [src]="placeholderImageUrl" [width]="placeholderImageSize" [height]="placeholderImageSize" />
		</div>
		-->
		<div class="spinner" *ngIf="busy">
			<mat-spinner color="primary" [diameter]="15" [strokeWidth]="1.5"></mat-spinner>
		</div>
		<mat-hint *ngIf="!showAddressList">e.g. 1 FLINDERS STREET MELBOURNE VIC 3000</mat-hint>
		<mat-error *ngIf="control.errors">{{ errorMessage }}</mat-error>
		<img *ngIf="showHintError && validationImage" class="validation-tick" [src]="validationImage" />
	</mat-form-field>
	<ul class="options" [ngClass]="{'options--scroll' : scroll}" *ngIf="showAddressList">
		<!-- [class.active-option]="i === activeOptionIndex" -->
		<li class="options--option" *ngFor="let a of addresses; let i = index" (click)="addressSelected(a)" [innerText]="getAddress(a)"></li>
		<!-- [class.active-option]="addresses && activeOptionIndex == addresses.length" -->
		<li class="options--option not-found" *ngIf="showManualEntryOption && showAddressList" (click)="addressSelected('manual')">
			<span>Can't find your address?</span>
			<span class="accent-fg underline">Manual Search</span>
		</li>
	</ul>
</div>